<template>
	<el-dialog
		title="新增成员"
		:visible.sync="dialogVisible"
		width="480px"
		:close-on-click-modal="false"
		@close="handleClose"
	>
		<el-form :model="form" :rules="rules" ref="formRef" label-width="80px">
			<el-form-item label="手机号" prop="mobile">
				<el-input v-model="form.mobile" placeholder="请输入手机号" maxlength="11"></el-input>
			</el-form-item>
			<el-form-item label="密码" prop="password">
				<el-input
					v-model="form.password"
					type="password"
					placeholder="请输入密码（6-20位）"
					show-password
					maxlength="20"
				></el-input>
			</el-form-item>
			<el-form-item label="备注" prop="remark">
				<el-input
					v-model="form.remark"
					type="textarea"
					placeholder="请输入备注（选填）"
					:rows="3"
					maxlength="100"
				></el-input>
			</el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button @click="dialogVisible = false">取 消</el-button>
			<el-button type="primary" @click="handleSubmit" :loading="loading">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { addUser } from '@/api/public'

export default {
	name: 'AddMemberDialog',
	data() {
		return {
			dialogVisible: false,
			loading: false,
			form: {
				mobile: '',
				password: '',
				remark: ''
			},
			rules: {
				mobile: [
					{ required: true, message: '请输入手机号', trigger: 'blur' },
					{ pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
				],
				password: [
					{ required: true, message: '请输入密码', trigger: 'blur' },
					{ min: 6, max: 20, message: '密码长度为6-20位', trigger: 'blur' }
				]
			}
		}
	},
	methods: {
		// 打开弹窗（供父组件调用）
		open() {
			this.form = { mobile: '', password: '', remark: '' }
			this.dialogVisible = true
		},

		// 关闭弹窗重置表单
		handleClose() {
			this.$refs.formRef && this.$refs.formRef.resetFields()
		},

		// 提交表单
		handleSubmit() {
			this.$refs.formRef.validate(async (valid) => {
				if (!valid) return
				this.loading = true
				try {
				const response = await addUser({
					mobile: this.form.mobile,
					password: this.form.password,
					remark: this.form.remark
				})
					if (response && response.code === 1) {
						this.$message.success('添加成功')
						this.dialogVisible = false
						this.$emit('success')
					} else {
						this.$message.error(response.msg || '添加失败')
					}
				}  finally {
					this.loading = false
				}
			})
		}
	}
}
</script>

<style lang="scss" scoped>
.dialog-footer {
	display: flex;
	justify-content: flex-end;
}
</style>
